import { Injectable, OnInit, inject } from '@angular/core';
import { Location } from '@angular/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router'
import { filter } from 'rxjs/operators';
import { Section } from '../models/sections.interface';
import { mainSection, settingsSection } from "../constants/sections.constant";
import { AppService } from './app.service';
import { TranslateService } from '@ngx-translate/core';
import { AppStateHolder } from '../shared/app-state.holder';
import { SessionService } from './session.service';
import { WorkspacePreferencesService } from './workspace-preferences.service';

import { Title } from '@angular/platform-browser';
import { map, mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private _router = inject(Router);
  private _appSrv = inject(AppService);
  private _ssnService = inject(SessionService);
  private location = inject(Location);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private titleService = inject(Title);
  translate = inject(TranslateService);
  private _prefs = inject(WorkspacePreferencesService);

  activeRoute: any;
  showSidebar: boolean = false;

  private _backEnabled: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public backEnabled: Observable<boolean> = this._backEnabled.asObservable();

  private _actions: BehaviorSubject<Array<Section>> = new BehaviorSubject<Array<Section>>([]);
  public actions: Observable<Array<Section>> = this._actions.asObservable();
  private _isExpanded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isExpanded: Observable<boolean> = this._isExpanded.asObservable();
  private _toggleMobile: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public toggleMobile: Observable<boolean> = this._toggleMobile.asObservable();

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() { }

  public subscribeEventsNavigation(): any {
    this._router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map(route => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        filter(route => route.outlet === 'primary'),
        mergeMap(route => route.data)
      )
      .subscribe(data => {
        this._setActions(data.urlAfterRedirects);
        const title = data['title'] || 'Suite Azienda'; // Use 'AmSuite' if no title is configured
        this.titleService.setTitle(title);
      });
  }

  public goBack(): void {
    this.showSidebar = false;
    this.location.back();
  }

  public setExpand(expand: boolean, persist: boolean = false): void {
    this._appSrv.setMenuIsOpen(expand);
    if (persist) {
      // Dual-write su Workspace (user-level): read-modify-write del raw-user corrente.
      this._prefs.putUser({ ...this._prefs.rawUser(), menuState: expand }).subscribe({ error: () => {} });
    }
    this._isExpanded.next(expand);
  }

  public get getStateExpanded(): boolean {
    return this._isExpanded.getValue();
  }

  public setToggleMobile(toggle: boolean): void {
    this._toggleMobile.next(toggle);
  }

  private _setActions(url: string): void {
    this.activeRoute = url;
    switch (url) {
      case "/accountSettings":
      case "/userInfo":
        this.showSidebar = true;
        this._backEnabled.next(true);
        this._actions.next(settingsSection);
        break;
      default:
        this.showSidebar = false;
        this._backEnabled.next(false);
        this._actions.next(mainSection);
        break;
    }
  }

}
